﻿

$(function () {
    UserCard.init();
});

var UserCard = UserCard || function () {
    function addEventHanders() {
        $(".js-delete-user").click(function () {
            // show confirmation dialog
            var $confirmDialog = $("#delete-user-confirm");
            $confirmDialog.fadeIn();
            $(".cancel", $confirmDialog).click(function () {
                $confirmDialog.fadeOut();
            });

            $(".confirm", $confirmDialog).click(function () {
                $confirmDialog.fadeOut();
                $("#delete-user-form").submit();
            });
        });

        $(document).on("click", ".js-disconnect-user", function () {
            // show confirmation dialog
            var form = $(this).closest("form");
            var $confirmDialog = $("#disconnect-user-confirm");
            $confirmDialog.fadeIn();
            $(".cancel", $confirmDialog).click(function () {
                $confirmDialog.fadeOut();
            });

            $(".confirm", $confirmDialog).click(function () {
                form.submit();
                $confirmDialog.fadeOut();
            });
        });

        $(document).on("change", ".js-row-checkbox", function () {
            var isChecked = $(this).is(":checked");
            var radioContainer = $(this).closest(".js-role-row").find(".js-radio-container");

            if (isChecked) {
                radioContainer.removeClass("hidden");
            } else {
                radioContainer.addClass("hidden");
            }
        });

        $(document).on("submit", ".js-custom-profile", function (e) {
            e.preventDefault();
            var form = $(this).closest("form");
            var customerNo = $(this).data("customerno");
            var userName = $(this).data("username");
            var roles = [];
            var rows = $(form).find(".js-role-row");
            $.each(rows, function (i, row) {
                var checkbox = $(row).find(".js-row-checkbox:checked");
                if (checkbox && checkbox.length > 0) {
                    var radios = $(row).find(".js-row-radio");
                    //if theres radio inputs
                    if (radios && radios.length > 0) {
                        var checkedRadio = $(row).find(".js-row-radio:checked");
                        //if one radio is checked
                        if (checkedRadio && checkedRadio.length > 0) {
                            roles.push(checkedRadio.val());
                        }
                    }
                    else {
                        //if no radios push value from checkbox
                        roles.push(checkbox.val());
                    }
                }
            });

            var $confirmDialog = $("#js-change-custom-roles-confirm");
            $confirmDialog.fadeIn();
            $(".cancel", $confirmDialog).click(function () {
                $confirmDialog.fadeOut();
            });

            var confirmButton = $(".confirm", $confirmDialog);
            confirmButton.unbind("click");
            $(confirmButton).click(function () {
                $.ajax({
                    dataType: "json",
                    url: "/api/usercard/save-roles",
                    type: "post",
                    cache: false,
                    data: {
                        userName: userName,
                        customerNumber: customerNo,
                        roles: roles
                    },
                    success: function (data) {
                        if (data) {
                            $(form).closest(".js-user-company-row").find(".js-show-custom-roles").trigger("click");
                        }
                    }
                });
                $confirmDialog.fadeOut();
            });
        });

        $(document).on("change", ".js-profile-dropdown", function (e) {
            var customerNo = $(this).data("customerno");
            var userName = $(this).data("username");
            var optionSelected = $("option:selected", this).val();
            var customRolesButtonContainer = $(this).closest(".usercard-account-details").find(".js-custom-roles-button-container");
            if (optionSelected == "Anpassad") {
                customRolesButtonContainer.removeClass("hidden");
            } else {
                customRolesButtonContainer.addClass("hidden");
                $.ajax({
                    dataType: "json",
                    url: "/api/usercard/save-profile",
                    type: "post",
                    cache: false,
                    data: {
                        userName: userName,
                        customerNumber: customerNo,
                        profileId: optionSelected
                    },
                    success: function (data) {
                    }
                });
            }
        });

        $(document).on("click", ".js-show-custom-roles", function (e) {
            e.preventDefault();
            var control = this;

            if (!$(control).closest(".setting-link").hasClass("is-active")) {
                $(control)
                    .closest(".setting-link")
                    .addClass("is-active");

                $(control)
                    .closest(".js-user-company-row")
                    .find(".js-custom-profile-block")
                    .slideDown("150", function () {
                        $(this)
                            .addClass("is-expanded")
                            .removeAttr("style");
                    });
            } else {
                $(control)
                    .closest(".js-user-company-row")
                    .find(".js-custom-profile-block")
                    .slideUp("150", function () {
                        $(control)
                            .closest(".setting-link")
                            .removeClass("is-active");

                        $(this)
                            .removeClass("is-expanded")
                            .removeAttr("style");
                    });
            }
        });

        $(document).on("click", ".js-close-custom-roles", function (e) {
            e.preventDefault();
            var control = this;

            $(control)
                .closest(".js-user-company-row")
                .find(".js-show-custom-roles")
                .trigger("click");
        });

        $(document).on("click", ".js-update-usersettings", function () {
            var inputsettings = [];
            var inputs = $(this).closest(".message-settings-content").find(".js-setting-input");
            inputs.each(function () {
                inputsettings.push(
                    {
                        CustomerOrgId: $(this).data("customerorgid"),
                        MessageSettingsId: $(this).data("messagesettingid"),
                        ModeOfDeliveryId: $(this).data("modeofdeliveryid"),
                        MsgAreaId: $(this).data("areaid"),
                        MsgTypeId: $(this).data("msgtypeid"),
                        UserID: $(this).data("userid"),
                        Value: $(this).is(":checked") ? true : false
                    });
            });
            if (inputsettings.length > 0) {
                $.ajax({
                    dataType: "json",
                    url: '/api/usercard/save-message-settings',
                    type: 'post',
                    cache: false,
                    data: { settings: inputsettings },
                    success: function (data) {
                        if (data === true) {
                            $("#confirm-save-message-settings").fadeIn();
                        }
                    }
                });
            }
        });

        $('#Cellphone').on('change', function () {
            var $element = $(this);

            var errorClass = 'error';
            var errorElement = 'div';

            // Clear previous error
            $element.removeClass(errorClass);
            $element.siblings('.' + errorClass).remove();

            var validationMessage = null
            var isFinnishCustomer = $element.data('is-finnish-customer');
            var swedishPhoneRegex = /^\+46[7-9][0-9\s-]{7,12}$/;
            var value = $element.val();

            if (!value) {
                validationMessage = window.validationMessage?.mobileSE?.required;
            } else if (isFinnishCustomer.toLowerCase() === "true") {
                var finnishPhoneRegex = /^\+358[\s\d]{6,}/;

                if (!finnishPhoneRegex.test(value)) {
                    validationMessage = window.validationMessage?.mobileFI?.valid;
                }
            } else if (!swedishPhoneRegex.test(value)) {
                validationMessage = window.validationMessage?.mobileSE?.valid;
            }

            if (validationMessage) {
                var $errorDiv = $('<' + errorElement + '>').addClass(errorClass).text(validationMessage);
                $element.addClass(errorClass);
                $element.after($errorDiv);
            }
        });
    }

    var loadCustomers = function () {
        var $body = $("#js-customers-list-body");
        if ($body.length === 0) {
            return;
        }

        var userName = $body.data("username");
        var $loader = $(".js-customers-loader");

        $.ajax({
            url: "/api/usercard/customers",
            type: "get",
            cache: false,
            data: { userName: userName },
            success: function (html, status, xhr) {
                $body.html(html);
                var isOwner = xhr.getResponseHeader("X-Is-Owner") === "True";
                $(".js-delete-user-container").toggleClass("hidden", isOwner);
            },
            complete: function () {
                $loader.hide();
            }
        });
    };

    var init = function () {
        addEventHanders();
        loadCustomers();
    };

    return {
        init: init
    };
}();
